export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23'),
	() => import('./nodes/24'),
	() => import('./nodes/25'),
	() => import('./nodes/26'),
	() => import('./nodes/27'),
	() => import('./nodes/28'),
	() => import('./nodes/29'),
	() => import('./nodes/30'),
	() => import('./nodes/31'),
	() => import('./nodes/32'),
	() => import('./nodes/33'),
	() => import('./nodes/34'),
	() => import('./nodes/35'),
	() => import('./nodes/36'),
	() => import('./nodes/37'),
	() => import('./nodes/38'),
	() => import('./nodes/39'),
	() => import('./nodes/40'),
	() => import('./nodes/41'),
	() => import('./nodes/42'),
	() => import('./nodes/43'),
	() => import('./nodes/44'),
	() => import('./nodes/45'),
	() => import('./nodes/46'),
	() => import('./nodes/47'),
	() => import('./nodes/48'),
	() => import('./nodes/49'),
	() => import('./nodes/50'),
	() => import('./nodes/51'),
	() => import('./nodes/52'),
	() => import('./nodes/53'),
	() => import('./nodes/54'),
	() => import('./nodes/55'),
	() => import('./nodes/56'),
	() => import('./nodes/57'),
	() => import('./nodes/58'),
	() => import('./nodes/59'),
	() => import('./nodes/60'),
	() => import('./nodes/61'),
	() => import('./nodes/62'),
	() => import('./nodes/63'),
	() => import('./nodes/64'),
	() => import('./nodes/65'),
	() => import('./nodes/66'),
	() => import('./nodes/67'),
	() => import('./nodes/68'),
	() => import('./nodes/69'),
	() => import('./nodes/70'),
	() => import('./nodes/71'),
	() => import('./nodes/72'),
	() => import('./nodes/73'),
	() => import('./nodes/74'),
	() => import('./nodes/75'),
	() => import('./nodes/76'),
	() => import('./nodes/77'),
	() => import('./nodes/78'),
	() => import('./nodes/79'),
	() => import('./nodes/80'),
	() => import('./nodes/81'),
	() => import('./nodes/82'),
	() => import('./nodes/83')
];

export const server_loads = [];

export const dictionary = {
		"/(public)": [69,[7]],
		"/(app)/account": [9,[2]],
		"/(app)/addons": [10,[2]],
		"/(app)/admin": [11,[2]],
		"/(app)/admin/access": [12,[2]],
		"/(app)/admin/ads": [13,[2]],
		"/(app)/admin/ads/assets": [14,[2]],
		"/(app)/admin/blog": [15,[2]],
		"/(app)/admin/coupons": [16,[2]],
		"/(app)/admin/desktop-licenses": [17,[2]],
		"/(app)/admin/desktop-runtime": [18,[2]],
		"/(app)/admin/file-shares": [19,[2]],
		"/(app)/admin/logs": [20,[2]],
		"/(app)/admin/meta-ads": [21,[2]],
		"/(app)/admin/notifications": [22,[2]],
		"/(app)/admin/payg-doc-credits": [23,[2]],
		"/(app)/admin/releases": [24,[2]],
		"/(app)/admin/support": [25,[2]],
		"/(app)/admin/users": [26,[2]],
		"/(public)/billing": [70,[7]],
		"/(public)/billing/success": [71,[7]],
		"/(app)/companies": [27,[2]],
		"/(app)/contacts": [28,[2]],
		"/(app)/credits": [29,[2,3]],
		"/(app)/credits/topups": [30,[2,3]],
		"/(app)/credits/usage": [31,[2,3]],
		"/(app)/customers": [32,[2]],
		"/(app)/dashboard": [33,[2]],
		"/(app)/desktop-connect": [35,[2]],
		"/(app)/desktop": [34,[2]],
		"/(public)/desktop/purchase/canceled": [72,[7]],
		"/(public)/desktop/purchase/success": [73,[7]],
		"/(app)/documents": [36,[2]],
		"/(app)/documents/ai": [38,[2]],
		"/(app)/documents/customer": [39,[2]],
		"/(app)/documents/customer/history": [40,[2]],
		"/(app)/documents/history": [41,[2]],
		"/(app)/documents/[id]": [37,[2]],
		"/(app)/etax": [42,[2,4]],
		"/(app)/etax/history": [43,[2,4]],
		"/(app)/etax/queue": [44,[2,4]],
		"/(app)/etax/settings": [45,[2,4]],
		"/(auth)/forgot-password": [64,[6]],
		"/(app)/help": [46,[2]],
		"/(app)/inbox": [47,[2]],
		"/(app)/install": [48,[2]],
		"/(app)/integrations": [49,[2]],
		"/(public)/invite": [74,[7]],
		"/(public)/invite/[token]": [75,[7]],
		"/line/browser-bridge": [80],
		"/line/liff": [81],
		"/line/liff/[...rest]": [82],
		"/line/share": [83],
		"/(auth)/login": [65,[6]],
		"/(public)/marketing/developer-api": [76,[7]],
		"/(app)/marketplace": [50,[2]],
		"/(public)/oauth/authorize": [77,[7]],
		"/(app)/payments": [51,[2]],
		"/(app)/payments/customer": [52,[2]],
		"/(app)/products": [53,[2]],
		"/(share)/public/documents/[token]": [79,[8]],
		"/(app)/purchases": [54,[2]],
		"/(auth)/register": [66,[6]],
		"/(app)/reports": [55,[2]],
		"/(app)/reports/daily": [56,[2]],
		"/(auth)/reset-password": [67,[6]],
		"/(app)/salespersons": [57,[2]],
		"/(app)/sandbox": [58,[2]],
		"/(app)/settings": [59,[2]],
		"/(app)/stock": [60,[2]],
		"/(app)/team": [61,[2,5]],
		"/(app)/team/history": [62,[2,5]],
		"/(public)/try": [78,[7]],
		"/(app)/updates": [63,[2]],
		"/(auth)/verify-email": [68,[6]]
	};

export const hooks = {
	handleError: (({ error }) => { console.error(error) }),
	
	reroute: (() => {}),
	transport: {}
};

export const decoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.decode]));
export const encoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.encode]));

export const hash = false;

export const decode = (type, value) => decoders[type](value);

export { default as root } from '../root.js';